import { Badge, Card, Col, Row } from "react-bootstrap"
import WhatsAppNotificationInfo from "../InformativeMessages/WhatsAppNotificationInformation/WhatsAppNotificationInfo"

interface NotificationSettingsProps {
  notificationSettings: {
    whatsApp: boolean
    email: boolean
    sms: boolean
  }
}

export default function NotificationSettings({
  notificationSettings
}: NotificationSettingsProps) {
  return (
    <Card className="mb-4">
      <Card.Header>
        <Card.Title className="mb-0">Notification Settings</Card.Title>
      </Card.Header>
      <Card.Body>
        <Row className="mb-2">
          <Col sm={4} md={2}><strong>WhatsApp:</strong></Col>
          <Col sm={8}>
            <Badge bg={notificationSettings.whatsApp ? 'success' : 'secondary'}>
              {notificationSettings.whatsApp ? 'On' : 'Off'}
            </Badge>
          </Col>
        </Row>
        <Row className="mb-2">
          <Col sm={4} md={2}><strong>Email:</strong></Col>
          <Col sm={8}>
            <Badge bg={notificationSettings.email ? 'success' : 'secondary'}>
              {notificationSettings.email ? 'On' : 'Off'}
            </Badge>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col sm={4} md={2}><strong>SMS:</strong></Col>
          <Col sm={8}>
            <Badge bg={notificationSettings.sms ? 'success' : 'secondary'}>
              {notificationSettings.sms ? 'On' : 'Off'}
            </Badge>
          </Col>
        </Row>
        {notificationSettings.whatsApp && (
          <WhatsAppNotificationInfo />
        )}
      </Card.Body>
    </Card>
  )
}